var _excluded = ["page"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import hyper from "@macrostrat/hyper";
import ColumnIcon from "../components/icons/ColumnIcon";
import LineIcon from "../components/icons/LineIcon";
import ElevationIcon from "../components/icons/ElevationIcon";
import FossilIcon from "../components/icons/FossilIcon";
import BedrockIcon from "../components/icons/BedrockIcon";
import { Button, ButtonGroup, Alignment, NonIdealState } from "@blueprintjs/core";
import { CloseableCard } from "../components/closeable-card";
import { useAppActions, useSearchState, MapLayer, useHashNavigate, MenuPage, useAppState } from "../app-state";
import { SearchResults } from "../components/searchbar";
import classNames from "classnames";
import styles from "./main.module.styl";
import loadable from "@loadable/component";
import UsageText from "../usage.mdx";
import Changelog from "~/changelog.mdx";
import { useLocation } from "react-router";
import { useTransition } from "transition-hook";
import useBreadcrumbs from "use-react-router-breadcrumbs";
import { isDetailPanelRouteInternal } from "../app-state/nav-hooks";
import { SettingsPanel, ExperimentsPanel } from "./settings-panel";
import { useState, useEffect } from "react";
import { LinkButton, LayerButton, ListButton } from "../components/buttons";

function ChangelogPanel() {
  return h("div.bp4-text.text-panel", [h(Changelog)]);
}

var AboutText = loadable(function () {
  return import("../components/About");
});
var h = hyper.styled(styles);

var TabButton = function TabButton(props) {
  var page = props.page,
      rest = _objectWithoutProperties(props, _excluded);

  var active = useAppState(function (s) {
    return s.menu.activePage;
  }) == page;
  var runAction = useAppActions();
  return h(Button, _objectSpread(_objectSpread({
    minimal: true,
    active: active,
    onClick: function onClick() {
      runAction({
        type: "set-menu-page",
        page: page
      });
    }
  }, rest), {}, {
    className: "tab-button"
  }));
};

var MenuGroup = function MenuGroup(props) {
  return h(ButtonGroup, _objectSpread({
    className: "menu-group",
    vertical: true,
    minimal: true,
    large: true,
    alignText: Alignment.LEFT
  }, props));
};

var LayerList = function LayerList(props) {
  var runAction = useAppActions();

  var toggleElevationChart = function toggleElevationChart() {
    runAction({
      type: "toggle-menu"
    });
    runAction({
      type: "toggle-elevation-chart"
    });
  };

  return h("div.menu-content", [h(MenuGroup, [h(LayerButton, {
    name: "Bedrock",
    layer: MapLayer.BEDROCK,
    icon: BedrockIcon
  }), h(LayerButton, {
    name: "Lines",
    layer: MapLayer.LINES,
    icon: LineIcon
  }), h(LayerButton, {
    name: "Columns",
    layer: MapLayer.COLUMNS,
    icon: ColumnIcon
  }), h(LayerButton, {
    name: "Fossils",
    layer: MapLayer.FOSSILS,
    icon: FossilIcon
  }), h(LayerButton, {
    name: "Satellite",
    layer: MapLayer.SATELLITE,
    icon: "satellite"
  })]), h(MenuGroup, [h(ListButton, {
    onClick: toggleElevationChart,
    icon: ElevationIcon
  }, "Elevation profile")])]);
};

var UsagePanel = function UsagePanel() {
  return h("div.text-panel", h(UsageText));
};

var locationTitleForRoute = {
  "/about": "About",
  "/usage": "Usage",
  "/settings": "Settings",
  "/experiments": "Experiments",
  "/layers": "Layers",
  "/changelog": "Changelog"
};
var menuBacklinkLocationOverrides = {
  "/changelog": "/about"
};

function useLastPageLocation() {
  var _menuBacklinkLocation, _locationTitleForRout;

  var breadcrumbs = useBreadcrumbs();
  if (breadcrumbs.length < 2) return null;
  var prevPage = breadcrumbs[breadcrumbs.length - 2];
  var currentPage = breadcrumbs[breadcrumbs.length - 1];
  var prevRoute = (_menuBacklinkLocation = menuBacklinkLocationOverrides[currentPage.match.pathname]) !== null && _menuBacklinkLocation !== void 0 ? _menuBacklinkLocation : prevPage.match.pathname;
  if (prevRoute == "/" || isDetailPanelRouteInternal(prevRoute)) return null;
  return {
    to: prevRoute,
    title: (_locationTitleForRout = locationTitleForRoute[prevRoute]) !== null && _locationTitleForRout !== void 0 ? _locationTitleForRout : "Back"
  };
}

function MenuHeaderButtons() {
  var backLoc = useLastPageLocation();

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  if (backLoc != null) {
    var _locationTitleForRout2;

    return h([h(LinkButton, {
      icon: "chevron-left",
      minimal: true,
      to: backLoc.to
    }, backLoc.title), h("h2.panel-title", (_locationTitleForRout2 = locationTitleForRoute[pathname]) !== null && _locationTitleForRout2 !== void 0 ? _locationTitleForRout2 : "")]);
  }

  return h("div.buttons", [h(TabButton, {
    icon: "layers",
    text: "Layers",
    page: MenuPage.LAYERS
  }), h(TabButton, {
    icon: "settings",
    text: "Settings",
    page: MenuPage.SETTINGS
  }), h(TabButton, {
    icon: "info-sign",
    text: "About",
    page: MenuPage.ABOUT
  }), h(TabButton, {
    icon: "help",
    text: "Usage",
    page: MenuPage.USAGE
  })]);
}

function HeaderWrapper(_ref) {
  var children = _ref.children,
      _ref$minimal = _ref.minimal,
      minimal = _ref$minimal === void 0 ? false : _ref$minimal;

  /* A small component that changes whether a "minimal" class is applied, but only if the item isn't hovered.
  This prevents buttons from moving around when the user is hovering over them. */
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var _useState3 = useState(minimal),
      _useState4 = _slicedToArray(_useState3, 2),
      isMinimal = _useState4[0],
      setIsMinimal = _useState4[1];

  var onMouseEnter = function onMouseEnter() {
    return setIsHovered(true);
  };

  var onMouseLeave = function onMouseLeave() {
    return setIsHovered(false);
  };

  useEffect(function () {
    if (isHovered) return;
    setIsMinimal(minimal);
  }, [minimal, isHovered]);
  var className = classNames("panel-header", {
    minimal: isMinimal
  });
  return h(CloseableCard.Header, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    className: className
  }, children);
}

var Menu = function Menu(props) {
  var className = props.className,
      menuPage = props.menuPage;

  var _useSearchState = useSearchState(),
      inputFocus = _useSearchState.inputFocus;

  var runAction = useAppActions();
  var isNarrow = menuPage == MenuPage.LAYERS || menuPage == MenuPage.SETTINGS;
  var isNarrowTrans = useTransition(isNarrow, 800);

  if (inputFocus) {
    return h(SearchResults, {
      className: className
    });
  }

  className = classNames(className, "menu-card", menuPage, {
    "narrow-card": isNarrowTrans.shouldMount
  }, "narrow-".concat(isNarrowTrans.stage));
  return h(CloseableCard, {
    onClose: function onClose() {
      runAction({
        type: "toggle-menu"
      });
    },
    insetContent: false,
    className: className,
    renderHeader: function renderHeader() {
      return h(HeaderWrapper, {
        minimal: isNarrow
      }, h(MenuHeaderButtons));
    }
  }, elementForMenuPage(menuPage));
};

function elementForMenuPage(page) {
  switch (page) {
    case MenuPage.LAYERS:
      return h(LayerList);

    case MenuPage.SETTINGS:
      return h(SettingsPanel);

    case MenuPage.ABOUT:
      return h(AboutText);

    case MenuPage.USAGE:
      return h(UsagePanel);

    case MenuPage.CHANGELOG:
      return h(ChangelogPanel);

    case MenuPage.EXPERIMENTS:
      return h(ExperimentsPanel);
  }
}

function NotFoundPage() {
  var navigate = useHashNavigate("/");
  return h("div.text-panel", h(NonIdealState, {
    title: "Unknown page",
    action: h(Button, {
      onClick: navigate,
      minimal: true,
      rightIcon: "chevron-right"
    }, "Main page")
  }));
}

export { MenuPage };
export default Menu;